import React from "react";
import { oneOfType, number, string } from "prop-types";
import { Typography, Divider } from "antd";

// Receipt-style summary pinned to the bottom of the modal.
const receiptStyle = {
  marginTop: 16,
  padding: "12px 16px",
  background: "#fafafa",
  border: "1px solid #f0f0f0",
  borderRadius: 8,
};
const receiptRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  padding: "2px 0",
};

export default function CampaignPriceReceipt({
  reimbursement,
  serviceFees,
  description,
  totalPrice,
  code,
  amazonUrl,
}) {
  return (
    <div style={receiptStyle}>
      <div style={receiptRow}>
        <Typography.Text type="secondary">
          Product Reimbursement
        </Typography.Text>
        <Typography.Text>${Number(reimbursement).toFixed(2)}</Typography.Text>
      </div>
      <div style={receiptRow}>
        <Typography.Text type="secondary">Service Fees</Typography.Text>
        <Typography.Text>${Number(serviceFees).toFixed(2)}</Typography.Text>
      </div>
      {description ? (
        // Mirrors the serviceFeeDescription the brand sees on their side.
        <div style={{ ...receiptRow, alignItems: "flex-start" }}>
          <Typography.Text type="secondary">Description</Typography.Text>
          <Typography.Text style={{ maxWidth: "70%", textAlign: "right" }}>
            {description}
          </Typography.Text>
        </div>
      ) : null}
      <Divider dashed style={{ margin: "8px 0" }} />
      <div style={receiptRow}>
        <Typography.Text strong style={{ fontSize: 16 }}>
          Total Price for ASIN{" "}
          {amazonUrl ? (
            <a href={amazonUrl} target="_blank" rel="noopener noreferrer">
              &quot;{code}&quot;
            </a>
          ) : (
            `"${code}"`
          )}
        </Typography.Text>
        <Typography.Text strong style={{ fontSize: 16 }}>
          ${Number(totalPrice).toFixed(2)}
        </Typography.Text>
      </div>
      <Typography.Text type="danger" style={{ fontSize: 12 }}>
        IMPORTANT: All campaigns with same ASIN will be changed to this price
      </Typography.Text>
    </div>
  );
}

CampaignPriceReceipt.propTypes = {
  reimbursement: oneOfType([number, string]),
  serviceFees: oneOfType([number, string]),
  description: string,
  totalPrice: oneOfType([number, string]),
  code: string,
  amazonUrl: string,
};
